import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  TRANSMITTALS_REPORT_GET_JOB_LIST: createSagaAction('TRANSMITTALS_REPORT_GET_JOB_LIST'),
  TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST: createSagaAction(
    'TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST'
  ),
  TRANSMITTALS_REPORT_GET_FULL_REPORT: createSagaAction('TRANSMITTALS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  transmittalsReportGetJobList: ({ filters }) => ({
    type: constants.TRANSMITTALS_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  transmittalsReportGetOrganizationList: ({ filters }) => ({
    type: constants.TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  transmittalsReportGetFullReport: ({ filters }) => ({
    type: constants.TRANSMITTALS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.TRANSMITTALS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.TRANSMITTALS_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.TRANSMITTALS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.TRANSMITTALS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.TRANSMITTALS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/transmittalsReportActions.js